/* eslint-disable unicorn/prevent-abbreviations */
import type { AxiosResponse } from 'axios';
import axios from 'axios';
import type { ReviewSearchType } from '../domain/review/index.js';

export interface FetchReviewsParams {
  authorId?: number[];
  companyId?: number[];
  companyName?: string[];
  dealArea?: string[];
  dealClose?: string[];
  dealDate?: string[];
  dealSizeMax?: number;
  dealSizeMin?: number;
  dealType?: string[];
  economicBuyerTitleKeywords?: string[];
  followedOnly?: boolean; // NOT IMPLEMENTED... // if true, only reviews from followed companies are returned
  gicsCode?: string[];
  limit?: number;
  offset?: number; // the offset for pagination
  orderBy?: string; // the field to order by
  orderDirection?: string; // the direction to order by
  reviewKeywords?: string[]; // review keywords to filter by
  searchType: ReviewSearchType;
  stakeholderTitleKeywords?: string[];
}

export const fetchReviews = async (parameters: FetchReviewsParams, token: string) => {
  const url = `${import.meta.env.VITE_API_BASE_URL}/review`;

  try {
    const response: AxiosResponse = await axios.get(
      url,

      {
        headers: {
          Authorization: token,
        },
        params: parameters,
      },
    );

    return response.data;
  } catch {
    throw new Error('Error fetching reviews');
  }
};
